module.exports = __webpack_public_path__ + "img/tech-support-icon.ccee41a4.svg";